import { uuid } from "@hex/common";

/**
 * Exports are all mocked for integration tests. See:
 * https://github.com/hex-inc/hex/blob/ff020357bc8bc5ad0aa7b229768b808dafe2c292/packages/integration-tests/jest.wrapper.ts#L70-L84
 *
 * These "document.head.dataset.*" attributes come from `packages/server/src/server.ts``
 * Naming convention documentation: https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dataset
 */
export const webClientVersion: string | undefined =
  document.head.dataset.webClientVersion;
export const webClientBuildTime: string | undefined =
  document.head.dataset.webClientBuildTime;
export const analyticsEnabled: boolean =
  document.head.dataset.analyticsEnabled === "true";
export const allowGlobalSso: boolean =
  document.head.dataset.allowGlobalSso === "true";
export const fePerfProfiling: boolean =
  document.head.dataset.fePerfProfiling === "true";
export const customerId: string | undefined = document.head.dataset.customerId;
export const userBearerToken: string | undefined =
  document.head.dataset.userBearerToken;
export const outputsDomainName: string | undefined =
  document.head.dataset.outputsDomainName;

// Single UUID per browser tab, shared across all iframe outputs so they land
// on the same subdomain and can reuse the same resource pool.
export const outputsTabId: string = uuid();
export const isSelfServeEnabled: boolean =
  document.head.dataset.selfServeEnabled === "true";
export const isSingleTenant: boolean =
  document.head.dataset.isSingleTenant === "true";
export const stripePublishableKey: string | undefined =
  document.head.dataset.stripePublishableKey;
export const turnstileSiteKey: string | undefined =
  document.head.dataset.turnstileSiteKey;
export const isTurnstileSignupEnabled = turnstileSiteKey != null;
export const launchDarklyDisabled: boolean =
  document.head.dataset.launchDarklyDisabled === "true";
export const launchDarklyClientId: string | undefined =
  document.head.dataset.launchDarklyClientId;
export const launchDarklyFlagStateJson: string | undefined =
  document.head.dataset.launchDarklyFlagState;
export const launchDarklyContextJson: string | undefined =
  document.head.dataset.launchDarklyContext;
export const datadogSite: string | undefined =
  document.head.dataset.datadogSite;
export const publicIps: string[] = document.head.dataset.publicIps
  ? // eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
    document.head.dataset.publicIps.split(",")
  : [];
export const isMagicLinkEnabled: boolean =
  document.head.dataset.magicLinkEnabled === "true";
export const staticAssetPath: string | undefined =
  document.head.dataset.staticAssetPath;
export const vegaInitializationBundle: string | undefined =
  document.head.dataset.vegaInitializationBundle;
export const websocketKeepAliveSeconds: string | undefined =
  document.head.dataset.websocketKeepAliveSeconds;
export const baseUrl: string | undefined = document.head.dataset.baseUrl;
export const pylonAppId: string | undefined = document.head.dataset.pylonAppId;
export const googleDriveClientId: string | undefined =
  document.head.dataset.googleDriveClientId;
export const googleDriveAppId: string | undefined =
  document.head.dataset.googleDriveAppId;
export const slackBotClientId: string | undefined =
  document.head.dataset.slackBotClientId;
